export interface RadioSettings {
  _id?: string
  stationName: string
  slogan: string
  city: string
  frequency: string
  description: string
  hours: string
  streamUrl: string
  nowPlayingTitle?: string
  nowPlayingHost?: string
  nowPlayingPhoto?: string
  logoUrl?: string
  iconUrl?: string
  seoTitle?: string
  seoDescription?: string
  whatsapp?: string
  address?: string
  playStoreUrl?: string
  appStoreUrl?: string
  cityImageUrl?: string
  pixKey?: string
  pixKeyType?: string
  pixBeneficiaryName?: string
  pixBeneficiaryCity?: string
  pixDocument?: string
  pixMessage?: string
  bannerRotation?: string
  creator: string
  createdAt: string
  updatedAt: string
}

export interface TeamMember {
  _id?: string
  name: string
  programName: string
  photoUrl: string
  days: string[]
  startTime: string
  endTime: string
  icon?: string
  order: number
  active: boolean
  creator: string
  createdAt: string
  updatedAt: string
}

export interface Banner {
  _id?: string
  title: string
  subtitle?: string
  imageUrl: string
  linkUrl?: string
  order: number
  durationSeconds?: number
  weight?: number
  active: boolean
  creator: string
  createdAt: string
  updatedAt: string
}

export interface SocialLink {
  _id?: string
  platform: string
  url: string
  order: number
  active: boolean
  creator: string
  createdAt: string
  updatedAt: string
}

export interface Partner {
  _id?: string
  name: string
  url: string
  logoUrl?: string
  order: number
  active: boolean
  creator: string
  createdAt: string
  updatedAt: string
}

export interface NewsBanner {
  _id?: string
  title: string
  mediaUrl: string
  mediaType: 'image' | 'video'
  linkUrl?: string
  weight: number
  active: boolean
  creator: string
  createdAt: string
  updatedAt: string
}

export const WEEK_DAYS = ['SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SÁB', 'DOM'] as const
